




















import { Component, Vue } from "vue-property-decorator";
import { TodayLoader, TodayData } from "../../guidelines/todayData";
import { DayDone } from "./guidelineApi";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import CzCard from "../cz/CzCard.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzRing from "../cz/CzRing.vue";
import ProgramProgress from "../programs/ProgramProgress.vue";

// The way into "Today" from the bookings list: the day's progress and one line per thing in progress (D41).
@Component({ components: { CzCard, CzTitle, CzRing, ProgramProgress } })
export default class TodayCard extends Vue {
  data: TodayData = TodayLoader.empty();

  get hasToday(): boolean {
    return this.total > 0 || this.data.treatmentFailed;
  }

  get visible(): boolean {
    return this.hasToday || this.data.programs.length > 0 || this.data.courses.length > 0;
  }

  get total(): number {
    return TodayLoader.count(this.data);
  }

  get done(): number {
    return TodayLoader.done(this.data);
  }

  get ringLabel(): string {
    return this.$t("{0} of {1} done today").toString().replace("{0}", String(this.done)).replace("{1}", String(this.total));
  }

  // The summary: treatment, guidelines, questionnaires and then each program and course in progress.
  get lines(): any[] {
    const out: any[] = [];
    const takes = TodayLoader.treatmentDue(this.data);
    if (takes.length) out.push(this.line("t", this.$t("Treatment").toString(), takes.filter((r: any) => r.items.every((i: any) => i.taken)).length, takes.length, "{0} of {1} takes", "/today#treatment"));
    const rows = this.data.rows.filter((r: any) => !r.ended);
    if (rows.length) out.push(this.line("g", this.$t("Guidelines").toString(), rows.filter((r: any) => r.todayStatus === DayDone).length, rows.length, "{0} of {1} today", "/today#guidelines"));
    if (this.data.surveys.length) out.push({ key: "s", name: this.$t("Questionnaires").toString(), text: this.count(this.data.surveys.length, "1 pending", "{0} pending"), to: "/today#questionnaires", value: 0, max: 0 });
    this.data.programs.forEach((e: any) => out.push(this.line("p" + e.id, e.name, ProgramPackTexts.done(e), ProgramPackTexts.sessions(e), "{0} of {1} done", "/today#programs")));
    this.data.courses.forEach((c: any) => out.push(this.line("c" + c.id, c.name, c.completedLessons, c.lessonCount, "{0} of {1} lessons", "/today#courses")));
    return out;
  }

  line(key: string, name: string, value: number, max: number, text: string, to: any): any {
    return { key, name, value, max, to, text: this.$t(text).toString().replace("{0}", String(value)).replace("{1}", String(max)) };
  }

  count(n: number, one: string, many: string): string {
    return n === 1 ? this.$t(one).toString() : this.$t(many).toString().replace("{0}", String(n));
  }

  get dateLabel(): string {
    if (!this.data.today) return "";
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long", day: "numeric", month: "long" }).format(new Date(this.data.today + "T12:00:00"));
  }

  async mounted() {
    this.data = await TodayLoader.load();
  }
}
